// extracted by mini-css-extract-plugin
export default {"badge":"BuildBadge_badge__rMD1S"};